/* tslint:disable */
/* eslint-disable */
/**
 * Supply API Gateway
 * A REST API responsible to serve and compose all supply-related data available at Taster
 *
 * The version of the OpenAPI document: 1.63
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CategoryFromJSON, CategoryToJSON, } from './Category';
import { ProviderProductConceptFromJSON, ProviderProductConceptToJSON, } from './ProviderProductConcept';
import { ProviderProductQuantityInCartFromJSON, ProviderProductQuantityInCartToJSON, } from './ProviderProductQuantityInCart';
/**
 * Check if a given object implements the ProviderProduct interface.
 */
export function instanceOfProviderProduct(value) {
    let isInstance = true;
    isInstance = isInstance && "uuid" in value;
    isInstance = isInstance && "reference" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "originalLabel" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "concepts" in value;
    isInstance = isInstance && "helperUnit" in value;
    isInstance = isInstance && "helperUnitRatio" in value;
    isInstance = isInstance && "unit" in value;
    isInstance = isInstance && "unitPrice" in value;
    isInstance = isInstance && "unitRatio" in value;
    isInstance = isInstance && "vat" in value;
    isInstance = isInstance && "available" in value;
    isInstance = isInstance && "availableForOrdering" in value;
    isInstance = isInstance && "batchSize" in value;
    isInstance = isInstance && "excludeFromShippingPolicies" in value;
    isInstance = isInstance && "hasSubstitutes" in value;
    return isInstance;
}
export function ProviderProductFromJSON(json) {
    return ProviderProductFromJSONTyped(json, false);
}
export function ProviderProductFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uuid': json['uuid'],
        'reference': json['reference'],
        'label': json['label'],
        'originalLabel': json['original_label'],
        'category': CategoryFromJSON(json['category']),
        'concepts': (json['concepts'].map(ProviderProductConceptFromJSON)),
        'helperUnit': json['helper_unit'],
        'helperUnitRatio': json['helper_unit_ratio'],
        'unit': json['unit'],
        'unitPrice': json['unit_price'],
        'unitRatio': json['unit_ratio'],
        'vat': json['vat'],
        'quantityInCart': !exists(json, 'quantity_in_cart') ? undefined : ProviderProductQuantityInCartFromJSON(json['quantity_in_cart']),
        'available': json['available'],
        'availableForOrdering': json['available_for_ordering'],
        'batchSize': json['batch_size'],
        'excludeFromShippingPolicies': json['exclude_from_shipping_policies'],
        'hasSubstitutes': json['has_substitutes'],
    };
}
export function ProviderProductToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uuid': value.uuid,
        'reference': value.reference,
        'label': value.label,
        'original_label': value.originalLabel,
        'category': CategoryToJSON(value.category),
        'concepts': (value.concepts.map(ProviderProductConceptToJSON)),
        'helper_unit': value.helperUnit,
        'helper_unit_ratio': value.helperUnitRatio,
        'unit': value.unit,
        'unit_price': value.unitPrice,
        'unit_ratio': value.unitRatio,
        'vat': value.vat,
        'quantity_in_cart': ProviderProductQuantityInCartToJSON(value.quantityInCart),
        'available': value.available,
        'available_for_ordering': value.availableForOrdering,
        'batch_size': value.batchSize,
        'exclude_from_shipping_policies': value.excludeFromShippingPolicies,
        'has_substitutes': value.hasSubstitutes,
    };
}
